import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponentComponent } from './pages/main-component/main-component.component';
import { MaplistComponent } from './pages/maplist/maplist.component';
import { AddmapdataComponent } from './pages/maplist/addmapdata/addmapdata.component';
import { MapviewComponent } from './pages/mapview/mapview.component';
import { EditmapdataComponent } from './pages/maplist/editmapdata/editmapdata.component';
import { HomeComponent } from './pages/home/home.component';
import { RailLabComponent } from './pages/home/rail-lab/rail-lab.component';
import { ThemeLabComponent } from './pages/theme-lab/theme-lab.component';
import { StoreStubComponent } from './pages/store/store-stub.component';
import { ActiveGamesComponent } from './pages/active-games/active-games.component';
import { CharacterPortfolioComponent } from './pages/character-portfolio/character-portfolio.component';
import { ContentCreatorComponent } from './pages/content-creator/content-creator.component';
import { SocialFeedComponent } from './pages/social-feed/social-feed.component';
import { SocialGroupComponent } from './pages/social-group/social-group.component';
import { CommunitiesComponent } from './pages/communities/communities.component';
import { SocialNotificationsComponent } from './pages/social-notifications/social-notifications.component';
import { CommunityComponent } from './pages/community/community.component';
import { CommunityFormComponent } from './pages/community-form/community-form.component';
import { CommunityJoinComponent } from './pages/community-join/community-join.component';
import { SocialGameGroupComponent } from './pages/social-game-group/social-game-group.component';
import { SocialProfileComponent } from './pages/social-profile/social-profile.component';
import { SocialPostComponent } from './pages/social-post/social-post.component';
import { SocialMessagesComponent } from './pages/social-messages/social-messages.component';
import { ContentCreatorDetailComponent } from './pages/content-creator/content-creator-detail/content-creator-detail.component';
import { GameMasterDetailComponent } from './pages/game-master-detail/game-master-detail.component';
import { GmplayComponent } from './pages/gmplay/gmplay.component';
import { PlayerComponent } from './pages/player/player.component';
import { PlayerDetailComponent } from './pages/player/player-detail/player-detail.component';
import { CookiespageComponent } from './pages/cookiespage/cookiespage.component';
import { InvitationpageComponent } from './pages/invitationpage/invitationpage.component';
import { InvitationDetailpageComponent } from './pages/invitationpage/invitation-detailpage/legacy-invitation-page/invitation-detailpage.component';
import { MapPlayerViewComponent } from './pages/character-portfolio/map-player-view/map-player-view.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { authGuard } from './auth.guard';
import { DowngradeGuard } from './guards/downgrade.guard';
import { AddContentComponent } from './pages/content-creator/add-content/add-content.component';
import { AitokenComponent } from './pages/content-creator/aitoken/aitoken.component';
import { AboutComponent } from './pages/about/about.component';
import { CreateGameMapViewComponent } from './pages/active-games/create-game-map-view/create-game-map-view.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { unsavedChangesGuard } from './pages/player/player-detail/can-deactive-guard/guards/unsaved-changes.guard';
import { CityMapViewComponent } from './pages/city-map-view/city-map-view.component';
import { LearnMoreComponent } from './pages/learn-more/learn-more.component';
import { FAQComponent } from './pages/faq/faq.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './pages/terms-of-service/terms-of-service.component';
import { unsavedContentGuard } from './pages/content-creator/add-content/guards/unsaved-content.guard';
import { MapModifyComponent } from './pages/maplist/map-modify/map-modify.component';
import { MapPacksComponent } from './pages/map-packs/map-packs.component';
import { SubscriptionPlanDetailsComponent } from './pages/subscription/modals/subscription-plan-details/subscription-plan-details.component';

import { ForgotPasswordComponent } from './pages/auth/forgot-password/forgot-password.component';
import { guestOnlyGuard } from './pages/auth/guest.guard';
import { LoginComponent } from './pages/auth/login/login.component';
import { ResetPasswordComponent } from './pages/auth/reset-password/reset-password.component';
import { SetNewPasswordComponent } from './pages/auth/set-new-password/set-new-password.component';
import { SignupPageComponent } from './pages/auth/signup/signup-page.component';
import { VerifyEmailPageComponent } from './pages/auth/verify-email/verify-email-page.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'rail-lab',
    component: RailLabComponent,
  },
  {
    path: 'theme-lab',
    component: ThemeLabComponent,
  },
  {
    path: 'store',
    component: StoreStubComponent,
  },
  // Sign-in (pages/auth). Old addresses still lead to the new pages.
  { path: 'login', component: LoginComponent, canActivate: [guestOnlyGuard] },
  { path: 'signup', component: SignupPageComponent, canActivate: [guestOnlyGuard] },
  { path: 'sign-up', redirectTo: 'signup' },
  { path: 'auth0', redirectTo: 'login' },
  { path: 'email-verify', redirectTo: 'login' },
  { path: 'verify-email', component: VerifyEmailPageComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'set-new-password', component: SetNewPasswordComponent },
  {
    path: 'maplist',
    component: MaplistComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'map/:map_id',
    component: MainComponentComponent,
  },
  {
    path: 'addmapdata',
    component: AddmapdataComponent,
  },
  {
    path: 'editmapdata',
    component: EditmapdataComponent,
  },
  {
    path: 'mapview/:map_id/:game_id',
    component: MapviewComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'map-view-player/:map_id/:game_id/:charcter_id',
    component: MapPlayerViewComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'activegames',
    component: ActiveGamesComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'char-portfolio',
    component: CharacterPortfolioComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'content-creator',
    component: ContentCreatorComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'social-feed',
    component: SocialFeedComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'social-group/:groupId',
    component: SocialGroupComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'social-game-group/:gameGroupId',
    component: SocialGameGroupComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'social-profile/:userId',
    component: SocialProfileComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'social-post/:postId',
    component: SocialPostComponent,
    canActivate: [DowngradeGuard]
  },
  { path: 'social-notifications', component: SocialNotificationsComponent, canActivate: [authGuard, DowngradeGuard] },
  // Communities: the fixed paths come before :slug (the backend never gives a
  // community the slug "new" or "join").
  { path: 'communities', component: CommunitiesComponent, canActivate: [authGuard, DowngradeGuard] },
  { path: 'communities/new', component: CommunityFormComponent, canActivate: [authGuard, DowngradeGuard] },
  { path: 'communities/join/:token', component: CommunityJoinComponent, canActivate: [authGuard] },
  { path: 'communities/:slug', component: CommunityComponent, canActivate: [authGuard, DowngradeGuard] },
  { path: 'communities/:slug/settings', component: CommunityFormComponent, canActivate: [authGuard, DowngradeGuard] },
  {
    path: 'social-messages',
    component: SocialMessagesComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'social-messages/:userId',
    component: SocialMessagesComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'add-edit-content',
    component: AddContentComponent,
    canDeactivate: [unsavedContentGuard],
  },
  {
    path: 'content-creator-detail',
    component: ContentCreatorDetailComponent,
    canActivate: [authGuard, DowngradeGuard],
  },
  {
    path: 'game-master-detail/:game_id',
    component: GameMasterDetailComponent,
    canActivate: [authGuard, DowngradeGuard],
  },
  {
    path: 'gmplay',
    component: GmplayComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'player',
    component: PlayerComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'player-detail/:player_id',
    component: PlayerDetailComponent,
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'cookiespage',
    component: CookiespageComponent,
  },
  {
    path: 'invitationpage/:userId',
    component: InvitationpageComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'invitationpage',
    component: InvitationpageComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'invitationdetail/:user_id/:invitation_id',
    component: InvitationDetailpageComponent,
    canActivate: [DowngradeGuard]
  },
  {
    path: 'user-profile',
    component: UserProfileComponent,
  },
  { path: 'aitoken', component: AitokenComponent },
  { path: 'about', component: AboutComponent },
  {
    path: 'creategame-mapview/:map_id/:map_name/:backRoute/:map_genre',
    component: CreateGameMapViewComponent,
  },
  { path: 'learn-more/:isAbout', component: LearnMoreComponent },
  { path: 'FAQ', component: FAQComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-of-service', component: TermsOfServiceComponent },
  {
    path: 'subscription',
    loadChildren: () =>
      import('./pages/subscription/subscription.module').then(
        (m) => m.SubscriptionModule,
      ),
  },
  {
    path: 'marketplace',
    loadChildren: () =>
      import('./pages/marketplace/marketplace.module').then(
        (m) => m.MarketplaceModule,
      ),
  },
  {
    path: 'city-map-view/:citycode/:mapcode/:game_id/:character_id',
    component: CityMapViewComponent,
  },

  {
    path: 'map-modify/:map_id',
    component: MapModifyComponent,
  },
  {
    path: 'map-packs',
    component: MapPacksComponent,
  },
  {
    path: 'map-packs/:slug',
    component: MapPacksComponent,
  },
  {
    path: 'plan-details',
    component: SubscriptionPlanDetailsComponent
  },
  {
    path: 'wiki',
    loadChildren: () =>
      import('./pages/wiki/wiki.module').then((m) => m.WikiModule),
  },
  {
    // Super-admin dashboards (SuperUser role only; see admin.guard.ts).
    path: 'admin',
    loadChildren: () =>
      import('./pages/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'error',
    component: ErrorPageComponent,
  },
  {
    path: '**',
    component: ErrorPageComponent,
    data: { kind: 'not-found' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }

